import { OnlineViewersCount, OnlineViewersTitle } from './../../atoms';

export const OnlineViewers = () => {
    return (
        <>
            <OnlineViewersTitle />
            <OnlineViewersCount />
        </>
    );
};
